var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.582,
    height: 26.235,
    viewBox: "0 0 26.582 26.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13540.473 13519.687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.691,11.911,12.17,17.584a.519.519,0,0,0,.214.991H37.426a.519.519,0,0,0,.214-.991L25.119,11.911a.519.519,0,0,0-.428,0",
    transform: "translate(-13552.087 -13531.302)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.905,11.615a.764.764,0,0,1,.317.069l12.521,5.673a.769.769,0,0,1-.317,1.469H12.384a.769.769,0,0,1-.317-1.469l12.521-5.673A.764.764,0,0,1,24.905,11.615Zm12.521,6.711a.269.269,0,0,0,.111-.513L25.016,12.139a.27.27,0,0,0-.222,0L12.273,17.812a.269.269,0,0,0,.111.513Z",
    transform: "translate(-13552.087 -13531.302)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.505,
    height: 1.315,
    transform: "translate(-13537.935 -13512.726)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25h22V1.565h-22Zm21.5.5H.25v.814h21Z",
    transform: "translate(-13537.935 -13512.726)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.505,
    height: 1.315,
    transform: "translate(-13537.935 -13512.726)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H21.5a.25.25,0,0,1,.25.25V1.315a.25.25,0,0,1-.25.25H0a.25.25,0,0,1-.25-.25V0A.25.25,0,0,1,0-.25Zm21.255.5H.25v.814h21Z",
    transform: "translate(-13537.935 -13512.726)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.505,
    height: 1.315,
    transform: "translate(-13537.935 -13496.968)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25h22V1.565h-22Zm21.5.5H.25v.815h21Z",
    transform: "translate(-13537.935 -13496.968)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.505,
    height: 1.315,
    transform: "translate(-13537.935 -13496.968)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H21.5a.25.25,0,0,1,.25.25V1.315a.25.25,0,0,1-.25.25H0a.25.25,0,0,1-.25-.25V0A.25.25,0,0,1,0-.25Zm21.255.5H.25v.815h21Z",
    transform: "translate(-13537.935 -13496.968)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.157,
    height: 1.952,
    transform: "translate(-13539.769 -13495.653)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25H25.407V2.2H-.25Zm25.157.5H.25V1.7H24.907Z",
    transform: "translate(-13539.769 -13495.653)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.157,
    height: 1.952,
    transform: "translate(-13539.769 -13495.653)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H25.157a.25.25,0,0,1,.25.25V1.952a.25.25,0,0,1-.25.25H0a.25.25,0,0,1-.25-.25V0A.25.25,0,0,1,0-.25Zm24.907.5H.25V1.7H24.907Z",
    transform: "translate(-13539.769 -13495.653)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13536.459 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25H4.7v1.6H-.25ZM4.2.25H.25v.6H4.2Z",
    transform: "translate(-13536.459 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13536.459 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H4.447A.25.25,0,0,1,4.7,0V1.1a.25.25,0,0,1-.25.25H0A.25.25,0,0,1-.25,1.1V0A.25.25,0,0,1,0-.25Zm4.2.5H.25v.6H4.2Z",
    transform: "translate(-13536.459 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13536.459 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25H4.7v1.6H-.25ZM4.2.25H.25v.6H4.2Z",
    transform: "translate(-13536.459 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13536.459 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H4.447A.25.25,0,0,1,4.7,0V1.1a.25.25,0,0,1-.25.25H0A.25.25,0,0,1-.25,1.1V0A.25.25,0,0,1,0-.25Zm4.2.5H.25v.6H4.2Z",
    transform: "translate(-13536.459 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.318,350.245h-2.267l.016-10.345h2.267Z",
    transform: "translate(-13704.436 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.568,350.5H168.8l.016-10.845h2.767ZM169.3,350h1.767l.015-9.845h-1.767Z",
    transform: "translate(-13704.436 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.318,350.245h-2.267l.016-10.345h2.267Z",
    transform: "translate(-13704.436 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.318,350.5h-2.267a.25.25,0,0,1-.25-.25l.016-10.345a.25.25,0,0,1,.25-.25h2.267a.25.25,0,0,1,.25.25l-.016,10.345A.25.25,0,0,1,171.318,350.5ZM169.3,350h1.767l.015-9.845h-1.767Z",
    transform: "translate(-13704.436 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13529.405 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25H4.7v1.6H-.25ZM4.2.25H.25v.6H4.2Z",
    transform: "translate(-13529.405 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13529.405 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H4.447A.25.25,0,0,1,4.7,0V1.1a.25.25,0,0,1-.25.25H0A.25.25,0,0,1-.25,1.1V0A.25.25,0,0,1,0-.25Zm4.2.5H.25v.6H4.2Z",
    transform: "translate(-13529.405 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13529.405 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25H4.7v1.6H-.25ZM4.2.25H.25v.6H4.2Z",
    transform: "translate(-13529.405 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13529.405 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H4.447A.25.25,0,0,1,4.7,0V1.1a.25.25,0,0,1-.25.25H0A.25.25,0,0,1-.25,1.1V0A.25.25,0,0,1,0-.25Zm4.2.5H.25v.6H4.2Z",
    transform: "translate(-13529.405 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.489,350.245h-2.267l.016-10.345h2.267Z",
    transform: "translate(-13926.554 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.739,350.5h-2.767l.016-10.845h2.767Zm-2.266-.5h1.767l.015-9.845h-1.767Z",
    transform: "translate(-13926.554 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.489,350.245h-2.267l.016-10.345h2.267Z",
    transform: "translate(-13926.554 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.489,350.5h-2.267a.25.25,0,0,1-.25-.25l.016-10.345a.25.25,0,0,1,.25-.25h2.267a.25.25,0,0,1,.25.25l-.016,10.345A.25.25,0,0,1,400.489,350.5Zm-2.017-.5h1.767l.015-9.845h-1.767Z",
    transform: "translate(-13926.554 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13522.353 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25H4.7v1.6H-.25ZM4.2.25H.25v.6H4.2Z",
    transform: "translate(-13522.353 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13522.353 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H4.447A.25.25,0,0,1,4.7,0V1.1a.25.25,0,0,1-.25.25H0A.25.25,0,0,1-.25,1.1V0A.25.25,0,0,1,0-.25Zm4.2.5H.25v.6H4.2Z",
    transform: "translate(-13522.353 -13509.893)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13522.353 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25H4.7v1.6H-.25ZM4.2.25H.25v.6H4.2Z",
    transform: "translate(-13522.353 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.447,
    height: 1.102,
    transform: "translate(-13522.353 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25H4.447A.25.25,0,0,1,4.7,0V1.1a.25.25,0,0,1-.25.25H0A.25.25,0,0,1-.25,1.1V0A.25.25,0,0,1,0-.25Zm4.2.5H.25v.6H4.2Z",
    transform: "translate(-13522.353 -13499.548)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.66,350.245h-2.267l.016-10.345h2.267Z",
    transform: "translate(-14148.672 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.91,350.5h-2.767l.016-10.845h2.767Zm-2.266-.5h1.767l.015-9.845h-1.767Z",
    transform: "translate(-14148.672 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.66,350.245h-2.267l.016-10.345h2.267Z",
    transform: "translate(-14148.672 -13849.241)",
    fill: "#4a4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.66,350.5h-2.267a.25.25,0,0,1-.25-.25l.016-10.345a.25.25,0,0,1,.25-.25h2.267a.25.25,0,0,1,.25.25l-.016,10.345A.25.25,0,0,1,629.66,350.5Zm-2.017-.5h1.767l.015-9.845h-1.767Z",
    transform: "translate(-14148.672 -13849.241)",
    fill: "#4a4c4d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.23e599d97befafc8559f6d332d9c6f1c.svg";
export { ForwardRef as ReactComponent };